import '@jkhy/platform-tools/components/symbols/jh-platform-symbol';
import { TmBaseComponent } from '@treasury/presentation';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

const LOGO_TAG_NAME = 'tm-bo-logo';

@customElement(LOGO_TAG_NAME)
export class TmBoLogoComponent extends TmBaseComponent {
    private readonly appName = 'Treasury Management';

    protected render() {
        return html`
            <div class="flex items-center space-x-2">
                <jh-platform-symbol symbol="shape-3"></jh-platform-symbol>
                <h6>
                    ${this.appName}
                    <span class="font-bold text-xxs align-text-top">TM</span>
                </h6>
            </div>
        `;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static styles = css`
        :host {
            display: block;
        }
        .text-xxs {
            font-size: 0.5rem;
        }
    `;
}

declare global {
    interface HTMLElementTagNameMap {
        [LOGO_TAG_NAME]: TmBoLogoComponent;
    }
}
